<div class="processing-loader-card">
  <div class="processing-loader-visual" aria-hidden="true">
    <span class="processing-loader-orbit"></span>
    <svg viewBox="0 0 200 150" focusable="false">
      <g class="processing-loader-connections">
        <path d="M100 75 C76 63 65 43 48 30" />
        <path d="M100 75 C127 62 139 43 155 29" />
        <path d="M100 75 C73 88 59 107 39 119" />
        <path d="M100 75 C126 87 142 104 164 117" />
      </g>
      <g class="processing-loader-nodes">
        <circle cx="48" cy="30" r="9" />
        <circle cx="155" cy="29" r="7" />
        <circle cx="39" cy="119" r="7" />
        <circle cx="164" cy="117" r="9" />
      </g>
      <g class="processing-loader-flashcard processing-loader-flashcard-one">
        <rect x="19" y="58" width="41" height="27" rx="6" />
        <path d="M29 68 H49 M29 75 H43" />
      </g>
      <g class="processing-loader-flashcard processing-loader-flashcard-two">
        <rect x="143" y="63" width="41" height="27" rx="6" />
        <path d="M153 73 H174 M153 80 H168" />
      </g>
      <g class="processing-loader-core">
        <circle cx="100" cy="75" r="25" />
        <path
          d="M100 59 L104 70 L116 75 L104 80 L100 92 L96 80 L84 75 L96 70 Z"
        />
      </g>
    </svg>
    <span class="processing-loader-spark processing-loader-spark-one"></span>
    <span class="processing-loader-spark processing-loader-spark-two"></span>
  </div>
  @if (displayMessage()) {
    <strong class="processing-loader-message">{{ displayMessage() }}</strong>
  }
  <span class="processing-loader-progress" aria-hidden="true">
    <i></i><i></i><i></i>
  </span>
</div>
